import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TimeAgo from 'react-timeago'
import AdminSteps from '../common/AdminSteps';
import { Row, Col } from 'react-bootstrap';
import config from '../../config';
import * as courseActions from '../../actions/coursesActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import * as commonActions from '../../actions/commonActions';
import Spinner from 'react-spinkit';
import label from '../../utils/lngEn';
import StudentForm from './StudentForm';
import { browserHistory } from 'react-router';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';
import AddLocksModal from '../groups/AddLocksModal';
import AddGSRequirementModal from '../common/AddGSRequirementModal';
import AddGSConflictModal from '../common/AddGSConflictModal';
import StudentPreferences from './StudentPreferences';
import { openInNewTab, serializeParams } from '../../utils/utils';

class StudentPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      studentDetails: {
        id: null
      },
      studentLoaded: false,
      showConfirmStudentDelete: false,
      progress: '',

      coursesLoaded: false,
      showAddLocksModal: false,
      locksModalValues: {
        title: '',
        gsId: '',
        type: '',
        initialValues: {}
      },

      conflicts: [],
      requirements: [],
      startConf: 0,
      endConf: 10,
      startReq: 0,
      endReq: 10,
      activeConflictPage: 1,
      activeReqPage: 1,
      showConfModal: false,
      showReqModal: false,
      conflictModalValues: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict: false
        }
      },
      reqModalValues: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict: false
        }
      },

      showConfirmRestrictionDelete: false,
      deleteRestrictionId: '',
      deleteRestrictionType: '',
      confirmDeleteRestrictionTitle: '',
      confirmDeleteRestrictionMsg: ''
    };

    this.handleStudentFormSubmit = this.handleStudentFormSubmit.bind(this);
    this.closeDeleteStudentModal = this.closeDeleteStudentModal.bind(this);
    this.handleDeleteStudent = this.handleDeleteStudent.bind(this);
    this.getStatus = this.getStatus.bind(this);
    this.closeAddLocksModal = this.closeAddLocksModal.bind(this);

    // Restrictions
    this.setRestrictionsToState = this.setRestrictionsToState.bind(this);
    this.handleRestrictionSearch = this.handleRestrictionSearch.bind(this);

    // Conflicts
    this.handleConflictPageChange = this.handleConflictPageChange.bind(this);
    this.openAddConflictModal = this.openAddConflictModal.bind(this);
    this.openEditConflictModal = this.openEditConflictModal.bind(this);
    this.closeAddConflictModal = this.closeAddConflictModal.bind(this);

    // Requirements
    this.openAddReqModal = this.openAddReqModal.bind(this);
    this.openEditReqModal = this.openEditReqModal.bind(this);
    this.closeAddReqModal = this.closeAddReqModal.bind(this);
    this.handleRequirementPageChange = this.handleRequirementPageChange.bind(this);

    // Delete Restriction
    this.showConfirmRestrictionDeleteModal = this.showConfirmRestrictionDeleteModal.bind(this);
    this.handleDeleteRestriction = this.handleDeleteRestriction.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
  }

  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if (this.props.studentId) {
      this.setState({ studentLoaded: false });
      this.props.studentActions.getStudentById(this.props.studentId).then(() => {
        let student = Object.assign({}, this.props.student);
        if (student.base_budget) {
          student.base_budget = student.base_budget / 100;
        }
        if (student.effective_budget) {
          student.effective_budget = student.effective_budget / 100;
        }
        this.setState({ studentDetails: student });
        this.props.commonActions.getAllLocks(this.props.studentId, config.students);
        this.props.commonActions
          .getAllGSRestrictions(this.props.studentId, config.students, config.conflicts)
          .catch(() => {
            console.log('conflicts rejected');
          });
        this.props.commonActions
          .getAllGSRestrictions(this.props.studentId, config.students, config.requirements)
          .catch(() => {
            console.log('requirements rejected');
          });
      });
      this.props.courseActions.getAllCourses().then(() => {
        if (this.refs.restrictions) {
          this.setState({ coursesLoaded: true });
        }
      });

      this.props.studentActions.getAllStudentOverrides(this.props.studentId);
    }
    this.getStatus(this.props.student);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.student.id && nextProps.student != this.props.student) {
      this.setState({ studentLoaded: false });
      let student = Object.assign({}, nextProps.student);
      if (student.base_budget) {
        student.base_budget = student.base_budget / 100;
      }
      if (student.effective_budget) {
        student.effective_budget = student.effective_budget / 100;
      }
      this.setState({ studentDetails: student, studentLoaded: true });
      this.getStatus(this.props.student);

      if (this.props.student.conflicts != nextProps.student.conflicts && nextProps.student.conflicts != null) {
        this.setRestrictionsToState(nextProps.student.conflicts, config.conflicts);
      }
      if (this.props.student.requirements != nextProps.student.requirements && nextProps.student.requirements != null) {
        this.setRestrictionsToState(nextProps.student.requirements, config.requirements);
      }
    }
    if (this.props.studentId && nextProps.courses != this.props.courses) {
      this.setState({ coursesLoaded: true });
      this.setRestrictionsToState(this.props.student.conflicts, config.conflicts); // check
      this.setRestrictionsToState(this.props.student.requirements, config.requirements); // check
    }
  }

  getStatus(student) {
    if (student.target_course_units == null && student.preference_count == 0) {
      this.setState({ progress: 'Pending' });
    } else if (student.target_course_units != null && student.preference_count == 0) {
      this.setState({ progress: 'In Progress' });
    } else if (student.preference_count > 0) {
      this.setState({ progress: 'Submitted' });
    }
  }

  // Student form - Handle submit
  handleStudentFormSubmit(values) {
    if (typeof values.base_budget == 'object') {
      values.base_budget = values.base_budget.value;
    }
    // if(!values.base_budget) {
    //   values.base_budget = 100;
    // }

    if (values.id) {
      this.props.studentActions.putStudent(values).then(() => {
        this.props.studentActions.getStudentById(this.props.studentId);
        this.props.studentActions.getAllStudents();
      });
    } else {
      this.props.studentActions.createStudent(values).then(res => {
        this.props.courseActions.getAllCourses().then(() => {
          this.props.studentActions.getStudentById(res.id);
          this.props.studentActions.getAllStudents();
          this.setState({ coursesLoaded: true });
          browserHistory.push('/administer/' + localStorage.getItem('run') + '/student/' + res.id);
        });
      });
    }
  }

  // Delete Student
  openDeleteStudentModal = () => () => {
    this.setState({ showConfirmStudentDelete: true });
  };

  handleDeleteStudent() {
    this.props.studentActions.deleteStudent(this.props.studentId).then(() => {
      this.props.studentActions.getAllStudents();
      browserHistory.push('/administer/' + localStorage.getItem('run') + '/students');
    });
  }

  closeDeleteStudentModal() {
    this.setState({ showConfirmStudentDelete: false });
  }

  handleDeleteLock(id) {
    this.props.commonActions.deleteLock(this.props.studentId, id, config.students).then(() => {
      this.props.commonActions.getAllLocks(this.props.studentId, config.students);
    });
  }

  // Locks Modal
  openLocksModal() {
    this.setState({
      showAddLocksModal: true,
      locksModalValues: {
        title: `${label.addLock}`,
        gsId: this.props.studentId,
        type: config.students,
        initialValues: {}
      }
    });
  }

  closeAddLocksModal() {
    this.setState({ showAddLocksModal: false });
  }

  // Handle Restriction item Search
  handleRestrictionSearch(e, type) {
    e.preventDefault();
    let term = e.target.value;
    if (term != '') {
      let arrUnique = this.props.runActions.searchRestrictions(
        term,
        type == config.conflicts ? this.props.student.conflicts : this.props.student.requirements,
        this.props.courses
      );

      type == config.conflicts
        ? this.setState({
            conflicts: arrUnique,
            startConf: 0,
            endConf: 10,
            activeConflictPage: 1
          })
        : this.setState({
            requirements: arrUnique,
            startReq: 0,
            endReq: 10,
            activeReqPage: 1
          });
    } else {
      type == config.conflicts
        ? this.setState({ conflicts: this.props.student.conflicts })
        : this.setState({ requirements: this.props.student.requirements });
    }
  }

  // Bind conflicts or requirements to local state
  setRestrictionsToState(restrictions, type) {
    if (type == config.conflicts) {
      this.setState({ conflicts: restrictions });
    } else if (type == config.requirements) {
      this.setState({ requirements: restrictions });
    }
  }

  // Delete Restriction Modal
  showConfirmRestrictionDeleteModal(id, type) {
    let item;
    if (type == config.conflicts) {
      item = this.state.conflicts.filter(r => {
        return r.id == id;
      });
    } else if (type == config.requirements) {
      item = this.state.requirements.filter(r => {
        return r.id == id;
      });
    }
    this.setState({ deleteRestrictionId: id });
    this.setState({ deleteRestrictionType: type });
    this.setState({ showConfirmRestrictionDelete: true });
    this.setState({ confirmDeleteRestrictionTitle: item[0].name });
    this.setState({
      confirmDeleteRestrictionMsg: `${
        type == config.conflicts ? label.deleteConfConfirmCustomMsg : label.deleteReqConfirmCustomMsg
      }`
    });
  }

  handleDeleteRestriction() {
    let c = this.state.deleteRestrictionId;
    if (c != '') {
      this.props.commonActions.deleteGSRestiction(
        this.props.studentId,
        this.state.deleteRestrictionId,
        config.students,
        this.state.deleteRestrictionType
      );
    }
    this.setState({ showConfirmRestrictionDelete: false });
  }

  closeDeleteModal() {
    this.setState({ showConfirmRestrictionDelete: false });
  }

  // Handle Conflict page change
  handleConflictPageChange(key) {
    this.setState({ activeConflictPage: key });
    if (key == 1) {
      this.setState({ startConf: 0, endConf: 10 });
    } else {
      let start = key * 10 - 10;
      let end = key * 10;
      this.setState({ startConf: start, endConf: end });
    }
  }

  // Conflicts
  openAddConflictModal() {
    this.setState({
      showConfModal: true,
      conflictModalValues: {
        title: `${label.createConflict}`,
        gsId: this.props.studentId,
        type: config.students,
        initialValues: {
          is_time_conflict: false
        }
      }
    });
  }

  openEditConflictModal(conflict) {
    this.setState({
      showConfModal: true,
      conflictModalValues: {
        title: `${label.editConflict}`,
        gsId: this.props.studentId,
        type: config.students,
        initialValues: {
          is_time_conflict: false,
          id: conflict.id,
          name: conflict.name,
          kind: conflict.kind.toString(),
          limit: conflict.limit.toString(),
          courses: conflict.courses
        }
      }
    });
  }

  closeAddConflictModal() {
    this.setState({ showConfModal: false });
  }

  // Requirements
  openAddReqModal() {
    this.setState({
      showReqModal: true,
      reqModalValues: {
        title: `${label.createRequirement}`,
        gsId: this.props.studentId,
        type: config.students,
        initialValues: {}
      }
    });
  }

  openEditReqModal(req) {
    this.setState({
      showReqModal: true,
      reqModalValues: {
        title: `${label.editRequirement}`,
        gsId: this.props.studentId,
        type: config.students,
        initialValues: {
          id: req.id,
          name: req.name,
          kind: req.kind.toString(),
          limit: req.limit.toString(),
          courses: req.courses
        }
      }
    });
  }

  closeAddReqModal() {
    this.setState({ showReqModal: false });
  }

  // Handle Requirement page change
  handleRequirementPageChange(key) {
    this.setState({ activeReqPage: key });
    if (key == 1) {
      this.setState({ startReq: 0, endReq: 10 });
    } else {
      let start = key * 10 - 10;
      let end = key * 10;
      this.setState({ startReq: start, endReq: end });
    }
  }

  parseCoursePreference = (preferences = [], courses = []) =>
    preferences.map(preference => ({
      ...commonActions.getCourseObjById(preference.course, courses),
      preference_class: preference.preference_class
    }));

  handleEmulateStudent = (student, runSlug) => () => {
    this.props.studentActions
      .emulateStudent(student.id)
      .then(authData => {
        const urlParams = {
          token: authData.token,
          expiration_date: authData.expiration_date,
          viewAs: 'emulate',
          target: student.user.email
        };
        const emulateUrl = `/rank/${runSlug}/login?${serializeParams(urlParams)}`;
        openInNewTab(emulateUrl);
      })
      .catch(err => console.log(err));
  };

  render() {
    const { student, courses, run, commonComponents } = this.props;
    const parsedCoursesPreference = this.parseCoursePreference(student.courses_preference, courses);
    const runName = localStorage.getItem('run');
    const { assignment_complete } = run;

    return (
      <Col md={12}>
        <div className="page-title">Manage Student</div>
        <AdminSteps active="-1" label={this.props.run.slug} assignment_complete={assignment_complete}/>
        {this.props.studentId ? (
          <button className="btn btn-ter pull-right delete-course" onClick={this.openDeleteStudentModal()}>
            Delete Student
          </button>
        ) : null}
        <Row>
          <Col md={8}>
            {(this.props.studentId && this.state.studentDetails.id != null) || !this.props.studentId ? (
              <div>
                {this.props.studentId ? (
                  <div className="page-subtitle">
                    <span className="sub-title-gray mr-2">{label.student}</span>
                    <span>{student.user.email}</span>
                    <button onClick={this.handleEmulateStudent(student, run.slug)} className="btn btn-ter emulate-btn">
                      EMULATE
                    </button>
                  </div>
                ) : (
                  <div className="page-subtitle">Create New Student</div>
                )}

                {this.props.studentId && this.props.student.id && this.state.studentLoaded ? (
                  <StudentForm
                    onSubmit={this.handleStudentFormSubmit}
                    adjustedBudget={this.props.student.effective_budget}
                    initialValues={this.state.studentDetails}
                  />
                ) : null}
                {!this.props.studentId && !this.state.studentLoaded ? (
                  <StudentForm onSubmit={this.handleStudentFormSubmit} initialValues={{ base_budget: 100 }} />
                ) : null}

                {this.props.studentId ? (
                  <div>
                    {commonComponents.StudentGroups}
                    <div ref="preferences">
                      {courses.length > 0 &&
                        parsedCoursesPreference.length > 0 && (
                          <StudentPreferences preference={parsedCoursesPreference} runName={runName} />
                        )}
                    </div>
                    <div ref="restrictions">
                      {this.state.coursesLoaded && commonComponents.RestrictionReleases}
                    </div>
                  </div>
                ) : null}

                {this.props.studentId && this.props.courses.length > 0 ? (
                  <div>
                    <AddLocksModal
                      closeModal={this.closeAddLocksModal}
                      showModal={this.state.showAddLocksModal}
                      onCancel={this.closeAddLocksModal}
                      initial={this.state.locksModalValues}
                    />
                    <AddGSConflictModal
                      closeModal={this.closeAddConflictModal}
                      showModal={this.state.showConfModal}
                      onCancel={this.closeAddConflictModal}
                      initial={this.state.conflictModalValues}
                    />
                    <AddGSRequirementModal
                      closeModal={this.closeAddReqModal}
                      showModal={this.state.showReqModal}
                      onCancel={this.closeAddReqModal}
                      initial={this.state.reqModalValues}
                    />
                  </div>
                ) : null}
              </div>
            ) : (
              <Spinner spinnerName="three-bounce" />
            )}
          </Col>
          <Col md={4}>
            {this.props.studentId && this.state.studentLoaded ? (
              <div className="sidebar-container">
                <div className="sidebar-header">{label.studentSelectionStatusTitle}</div>
                <div className="progress-box mt-4">
                  {this.state.progress}

                  <p>
                    {this.props.student.preference_count
                      ? this.props.student.preference_count < 1
                        ? 'No rankings.'
                        : this.props.student.preference_count == 1
                          ? this.props.student.preference_count + ' class ranking.'
                          : this.props.student.preference_count > 1
                            ? this.props.student.preference_count + ' class rankings.'
                            : null
                      : 'No rankings.'}
                  </p>
                  {!student.last_login && <p>This student has never logged in</p>}
                  {student.last_login && <p>Last logged in <TimeAgo date={student.last_login} /></p>}
                  {!assignment_complete && student.courses_preference &&
                    student.courses_preference.length > 0 &&
                    <p>Rankings last updated <TimeAgo date={student.courses_preference[0].created_at} /></p>}
                </div>
              </div>
            ) : null}
          </Col>
        </Row>
        <ConfirmDeleteModal
          closeModal={this.closeDeleteStudentModal}
          showModal={this.state.showConfirmStudentDelete}
          onCancel={this.closeDeleteStudentModal}
          customTitle={this.props.student.user.email}
          customMsg={label.deleteStudentCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteStudent}
        />
        <ConfirmDeleteModal
          closeModal={this.closeDeleteModal}
          showModal={this.state.showConfirmRestrictionDelete}
          onCancel={this.closeDeleteModal}
          customTitle={this.state.confirmDeleteRestrictionTitle}
          customMsg={this.state.confirmDeleteRestrictionMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteRestriction}
        />
      </Col>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let studentId = null;
  if (ownProps.params.id) {
    studentId = ownProps.params.id;
  }
  return {
    run: state.run,
    studentId: studentId,
    student: state.student,
    courses: state.courses,
    school: state.school
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentPage);



// WEBPACK FOOTER //
// ./src/components/students/StudentPage.js